import { ContactsOutlined } from "@material-ui/icons";
import _, { mapKeys, camelCase } from "lodash";
export class ApiAdapter {
  public programId: number;
  // public baseURL: string;
  public setupURL: string;
  // public profileURL: string;
  public token: string;
  public HTTPPostHeader: {};
  // public makeCamelCase: any;

  constructor(monitorProgramId: number = -1) {
    this.programId = monitorProgramId;

    this.setupURL = "/goal_templates/setup";

    this.token = $('meta[name="csrf-token"]').attr("content");
    this.HTTPPostHeader = {
      Accept: "application/json, text/javascript, */*; q=0.01",
      "Content-type": "application/json",
      "X-PREVENT-BASIC-AUTH": "true",
      "X-CSRF-Token": this.token,
      "X-Requested-With": "XMLHttpRequest",
    };
  }

  buildHistoriesURL(id) {
    return `/patient/${id}/goal_history`;
  }

  camelizeKeys(obj) {
    if (Array.isArray(obj)) {
      return obj.map((v) => this.camelizeKeys(v));
    } else if (obj !== null && obj.constructor === Object) {
      return Object.keys(obj).reduce(
        (result, key) => ({
          ...result,
          [camelCase(key)]: this.camelizeKeys(obj[key]),
        }),
        {}
      );
    }
    return obj;
  }

  // load prerequisite data in MonitorProgram editor.
  // goaltemplates/setup => GoalTemplateController#setup
  loadSetup() {
    return fetch(this.setupURL)
      .then((response) => response.json())
      .then((data) => {
        return this.camelizeKeys(data);
      });
  }

  // load existing goal templates in MonitorProgram editor.
  // monitor_programs/:id/goal_templates => GoalTemplateController#index
  loadGoalTemplates(monitorProgramId) {
    return fetch(`/monitor_programs/${monitorProgramId}/goal_templates`)
      .then((response) => response.json())
      .then((data) => {
        var goalTemplates = data.goal_templates.map((template) => {
          var parsedTemplate = JSON.parse(template);
          return this.camelizeKeys(parsedTemplate);
        });

        return goalTemplates;
      });
  }

  buildGoalPreview(patientProfileId, templateId) {
    return fetch(
      `/monitor_profile/${patientProfileId}/goal_template/${templateId}/new_goal`
    )
      .then((response) => response.json())
      .then((payload) => {
        return this.camelizeKeys(payload);
      });
  }

  loadEnrolmentData(id) {
    return fetch(`/monitor_profile/${id}/goal_setup`)
      .then((response) => response.json())
      .then((payload) => {
        let formattedPayload = {
          goalTemplates: payload["goal_templates"].map((template) =>
            JSON.parse(template)
          ),

          patientGoals: payload["patient_goals"].map((goal) =>
            JSON.parse(goal)
          ),
        };
        return this.camelizeKeys(formattedPayload);
      });
  }

  retrieveGoalHistories(id) {
    return fetch(`${this.buildHistoriesURL(id)}/active`)
      .then((response) => {
        return response.json();
      })
      .then((payload) => {
        payload.payload = payload.payload.map((goal) => {
          goal = JSON.parse(goal);
          goal = this.camelizeKeys(goal);
          return goal;
        });

        this.camelizeKeys(payload);
        return payload;
      });
  }
}
